export default __webpack_public_path__ + "static/media/framerMotionBW.9e3df7e5.webp";